<template>
	<div class="w-full">
		<div v-if="buttonsType == 'single'" id="single-button" class="button-container">
			<a
				v-if="!canDeselect"
				:class="{'selected': getPrice() == 'Selected', 'disabled': isLoading || disableButton}"
				class="btn btn-green btn-outline"
				@click="addPartToBuild()"
			>
				{{ getPrice() }}
			</a>
			<a
				v-else
				:class="{'selected': getSelectedExtrasClass(), 'disabled': isLoading || disableButton}"
				class="btn btn-green btn-outline"
				@click="addPartsToBuild()"
			>
				{{ getPrice() }}
			</a>
		</div>
		<div v-if="buttonsType == 'selects'" id="double-select" class="button-container">
			<div class="green-drop select-number">
				<button
					v-if="!activeBuild[partName].length"
					:class="{'selected': activeBuild[partName].products_id == partInfo.products_id}"
					:disabled="isLoading || disableButton"
					type="button"
					data-toggle="dropdown"
					aria-haspopup="true"
					aria-expanded="false"
					class="btn btn-green"
				>
					<span class="m-l fa fa-chevron-down"/>
					{{ activeBuild[partName].products_id == partInfo.products_id ? activeBuild[partName].quantity : '0' }}
				</button>
				<button
					v-else
					:class="{'selected': activeBuild[partName][getBuildPartIndex()] && activeBuild[partName][getBuildPartIndex()].products_id == partInfo.products_id}"
					:disabled="isLoading || disableButton"
					type="button"
					data-toggle="dropdown"
					aria-haspopup="true"
					aria-expanded="false"
					class="btn btn-green"
				>
					<span class="m-l fa fa-chevron-down"/>
					{{
						activeBuild[partName][getBuildPartIndex()] && activeBuild[partName][getBuildPartIndex()].products_id == partInfo.products_id ?
							activeBuild[partName][getBuildPartIndex()].quantity :
							'0'
					}}
				</button>
				<ul class="dropdown-menu">
					<li>
						<a @click="setBuildPartWithOptions(null, 'empty')">
							<p class="text-blue m-b-0 pointer">0</p>
						</a>
					</li>
					<template v-for="(quantity, index) in rowStructure.availabeQuantity">
						<li :key="'selects-qty-' + index + '-' + partInfo.products_id">
							<a @click="setBuildPartWithOptions(null, quantity)">
								<p class="text-blue m-b-0 pointer">{{ quantity }}</p>
							</a>
						</li>
					</template>
				</ul>
			</div>
			<div class="green-drop select-capacity">
				<button
					v-if="activeBuild[partName].length == undefined"
					:class="{'selected': activeBuild[partName].products_id == partInfo.products_id}"
					:disabled="isLoading || disableButton"
					type="button"
					data-toggle="dropdown"
					aria-haspopup="true"
					aria-expanded="false"
					class="btn btn-green btn-outline"
				>
					<span class="m-l fa fa-chevron-down"/>
					{{ getBuildPartText(activeBuild[partName]) }}
				</button>
				<button
					v-else
					:class="{'selected': activeBuild[partName][getBuildPartIndex()] && activeBuild[partName][getBuildPartIndex()].products_id == partInfo.products_id}"
					:disabled="isLoading || disableButton"
					type="button"
					data-toggle="dropdown"
					aria-haspopup="true"
					aria-expanded="false"
					class="btn btn-green btn-outline"
				>
					<span class="m-l fa fa-chevron-down"/>
					{{ getBuildPartText(activeBuild[partName]) }}
				</button>
				<ul class="dropdown-menu">
					<template v-for="(option, index) in partInfo.options">
						<li :key="'row-button-' + index + '-' + option.id">
							<a @click="setBuildPartWithOptions(option)" >
								<p class="text-blue m-b-0 pointer">
									<template v-if="option.slots">
										{{ getRealCapacity(option) }}
									</template>
									<template v-else>
										{{ option.capacity }}
									</template>
									({{ getPriceProductsOptions(option) }})
								</p>
							</a>
						</li>
					</template>
				</ul>
			</div>
		</div>
		<div v-if="buttonsType == 'double'" id="double-select-button" class="button-container">
			<div class="green-drop">
				<button
					:class="{'selected': getPrice() == 'Selected'}"
					:disabled="isLoading || disableButton"
					type="button"
					data-toggle="dropdown"
					aria-haspopup="true"
					aria-expanded="false"
					class="btn btn-green"
				>
					<span class="m-l fa fa-chevron-down"/>
					{{
						getBuildPartIndex() >= 0 ?
							activeBuild[partName][getBuildPartIndex()].quantity :
							activeBuild[partName].products_id == partInfo.products_id ?
								activeBuild[partName].quantity :
								'0'
					}}
				</button>
				<ul class="dropdown-menu">
					<li>
						<a @click="setMultipleBuildParts('empty')">
							<p class="text-blue m-b-0 pointer">0</p>
						</a>
					</li>
					<template v-for="(quantity, index) in rowStructure.availabeQuantity">
						<li :key="'double-select-qty-' + index + '-' + partInfo.products_id">
							<a @click="setMultipleBuildParts(quantity)">
								<p class="text-blue m-b-0 pointer">{{ quantity }}</p>
							</a>
						</li>
					</template>
				</ul>
			</div>
			<a
				v-if="!(isLoading || disableButton)"
				:class="{'selected': getPrice() == 'Selected'}"
				class="btn btn-green btn-outline"
				@click="setMultipleBuildParts(activeBuild[partName][getBuildPartIndex()] ? activeBuild[partName][getBuildPartIndex()].quantity : 0)"
			>
				{{ getPrice() }}
			</a>
			<a
				v-else
				:class="{'selected': getPrice() == 'Selected'}"
				class="btn btn-green btn-outline"
			>
				{{ getPrice() }}
			</a>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import duplicate from "@m/duplicate";

export default {
	name: "RowButtons",
	mixins: [
		duplicate
	],
	props: {
		partName: {
			type: String,
			default: ""
		},
		partInfo: {
			type: Object,
			default() {
				return {};
			}
		},
		buttonsType: {
			type: String,
			default: ""
		},
		canDeselect: {
			type: Boolean,
			default: false
		},
		rowStructure: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	data() {
		return {
			disableButton: false,
			initialized: false
		};
	},
	computed: {
		...mapState({
			activeBuild: state => state.Step4.activeBuild,
			isLoading: state => state.Step4.isLoading
		}),
		...mapGetters(["buildPrice", "isPreventRule", "sessionData", "sessionGamesData"])
	},
	watch: {
		isLoading(state) {
			if (state == false) {
				this.disableButton = state;
			}
		}
	},
	methods: {
		...mapActions(
			["changeBuildPart",
				"setBuildPrice",
				"pushBuildPart",
				"removeBuildPart",
				"setPreviousBuild",
				"changeActiveRules",
				"changePreventRuleValidator",
				"setPreviousPartQuantity",
				"changeLoadingState"]
		),
		async addPartToBuild() {
			if (await this.checkOwnership()) {
				this.disableButton = true;
				this.changeLoadingState(true);
				this.setPreviousBuild(this.activeBuild);
				axios({
					url: `/update-part/${this.partInfo.id}/${this.activeBuild[this.partName].id}?pid=${this.partInfo.products_id}&validate=true&step4=true`,
					method: "GET",
					headers: {
						"token": CONFIG.SESSION
					}
				}).then((response) => {
					this.changeBuildPrice(response.data);
					this.changeLoadingState(false);
				});
			} else {
				await this.duplicateBuild();
				await this.getSessionData();
				this.addPartToBuild();
			}
		},
		getBuildPartIndex() {
			const productIndex = _.findIndex(this.activeBuild[this.partName], {
				products_id: this.partInfo.products_id
			});

			// Testing
			if (!this.initialized && productIndex >= 0) {
				this.addFanOrder();
				this.initialized = true;
			}

			return productIndex;
		},
		getBuildPartText(buildPart) {
			if (!buildPart && !buildPart.capacity) {
				return "";
			}

			let capacity = this.partName == "ram" ? this.getRealCapacity(this.partInfo) : this.partInfo.capacity.replace(".0", "");
			const defaultText = `${capacity} (+$${this.partInfo.price})`;

			if (Array.isArray(buildPart)) {
				const part = buildPart.find(part => part.products_id == this.partInfo.products_id);

				return part ? part.capacity.replace(".0", "") : defaultText;
			} else {
				if (buildPart.products_id == this.partInfo.products_id) {
					capacity = buildPart.capacity;
					if (this.partName == "ram") {
						const product = this.sessionData.ram.find(ram => ram.products_id == buildPart.products_id);
						const variant = product.options.find(ram => ram.id == buildPart.id);
						capacity = this.getRealCapacity(variant);
					}
					return capacity;
				}
			}
			return defaultText;
		},
		getPriceProductsOptions(option) {
			let price = 0;

			if (_.isArray(this.activeBuild[this.partName])) {
				const part = this.activeBuild[this.partName].find(part => part.products_id == this.partInfo.products_id);
				if (part) {
					const quantity = part.quantity ? part.quantity : 1;
					price = (Number(option.price) - Number(part.price)) * quantity;
				} else {
					price = option.price;
				}
			} else {
				price = (Number(option.price) - Number(this.activeBuild[this.partName].price)) * Number(this.activeBuild[this.partName].quantity);
			}

			price = Math.trunc(price).toFixed(2);
			price = price == 0 ? "Selected" : price > 0 ? `+$${price}` : `-$${price * -1}`;
			return price;
		},
		getPrice() {
			const partIndex = this.getBuildPartIndex();
			const partPrice = this.partInfo.price;
			let price = this.partInfo.price;
			const partName = this.partName;
			let refId = "products_id";

			if (price == "0.00") {
				return price;
			}

			if (this.activeBuild[partName] && this.activeBuild[partName].price) {
				if (this.activeBuild[partName].quantity) {
					price = Number(partPrice) * Number(this.activeBuild[partName].quantity) - Number(this.activeBuild[partName].price) * Number(this.activeBuild[partName].quantity);
				} else {
					price = Number(partPrice) - Number(this.activeBuild[partName].price);
				}
			}

			if (partName && partIndex >= 0) {
				price = Number(partPrice) - Number(this.activeBuild[partName][partIndex].price);
			}

			price = Number.parseFloat(price).toFixed(2);

			if (this.partName == "case") {
				if (+this.activeBuild[this.partName].is_limited) {
					if (this.rowStructure.id == "case-options") {
						return price == 0 ? "$0" : (price > 0 ? `+$${price}` : `-$${price * -1}`);
					} else {
						refId = "id";
					}
				} else {
					if (this.rowStructure.id == "limited-cases") {
						return price == 0 ? "$0" : (price > 0 ? `+$${price}` : `-$${price * -1}`);
					}
				}
			}

			let productsId = this.activeBuild[partName][refId];
			if (!productsId && partIndex >= 0) {
				productsId = this.activeBuild[partName][partIndex][refId];
			}

			let results = productsId == this.partInfo[refId] ? "Selected" : price > 0 ? `+$${price}` : `-$${price * -1}`;

			if (results == "-$0") {
				results = "$0";
			}

			//if we get -0 lol selcted
			if (results == "Selected" && (partName == "caseFans" || this.buttonsType == "double" || partName == "hdd" || this.canDeselect)) {
				results = "Selected";
			}

			return results;
		},
		getSelectedExtrasClass() {
			if (this.activeBuild[this.partName]) {
				if (Array.isArray(this.activeBuild[this.partName])) {
					if (this.activeBuild[this.partName].find(part => part.products_id === this.partInfo.products_id)) {
						return true;
					}
				} else {
					if (this.activeBuild[this.partName].products_id === this.partInfo.products_id) {
						return true;
					}
				}
			}

			return false;
		},
		async addPartsToBuild() {
			if (await this.checkOwnership()) {
				this.setPreviousBuild(this.activeBuild);
				this.disableButton = true;
				this.changeLoadingState(true);
				if (this.getBuildPartIndex() >= 0 || this.activeBuild[this.partName].id == this.partInfo.id) {
					axios({
						url: `/delete-part/${this.partInfo.id}?pid=${this.partInfo.products_id}&validate=true&step4=true`,
						method: "GET",
						headers: {
							"token": CONFIG.SESSION
						}
					}).then(response => {
						this.changeBuildPrice(response.data);
						this.changeLoadingState(false);
					});
				} else {
					axios({
						url: `/update-part-qty/${this.partInfo.id}/1?pid=${this.partInfo.products_id}&validate=true&step4=true`,
						method: "GET",
						headers: {
							"token": CONFIG.SESSION
						}
					}).then(response => {
						this.changeBuildPrice(response.data);
						this.changeLoadingState(false);
					});
				}
			} else {
				await this.duplicateBuild();
				await this.getSessionData();
				this.addPartsToBuild();
			}
		},
		async setBuildPartWithOptions(partOption, quantity) {
			if (await this.checkOwnership()) {
				this.setPreviousBuild(this.activeBuild);
				let selectedOption = _.cloneDeep(partOption);
				const buildPartIndex = this.getBuildPartIndex();
				let requestUrl = "";

				this.disableButton = true;
				this.changeLoadingState(true);

				if (quantity == "empty") {
					if (_.isArray(this.activeBuild[this.partName]) && this.getBuildPartIndex() >= 0) {
						axios({
							url: `/delete-part/${this.partInfo.id}?pid=${this.partInfo.products_id}&validate=true&step4=true`,
							method: "GET",
							headers: {
								"token": CONFIG.SESSION
							}
						}).then(response => {
							this.changeBuildPrice(response.data);
							this.changeLoadingState(false);
						});
					} else {
						this.changeLoadingState(false);
						this.disableButton = false;
					}

					return;
				}

				let buildPart = null;
				if (_.isArray(this.activeBuild[this.partName])) {
					buildPart = _.cloneDeep(this.activeBuild[this.partName][buildPartIndex]);

					if (!buildPart) {
						buildPart = _.cloneDeep(this.partInfo);
						buildPart.quantity = 1;
					}
				} else {
					buildPart = _.cloneDeep(this.activeBuild[this.partName]);

					if (!buildPart) {
						buildPart = _.cloneDeep(this.partInfo.options[0]);
					}
				}

				if (quantity) {
					buildPart.quantity = quantity;
				}

				if (!selectedOption) {
					if (!_.isArray(this.activeBuild[this.partName]) && this.activeBuild[this.partName].products_id !== this.partInfo.products_id) {
						selectedOption = Object.assign(_.cloneDeep(this.partInfo), this.partInfo.options[0]);
						if (quantity) {
							selectedOption.quantity = quantity;
						}
					} else {
						selectedOption = buildPart;
					}
				} else {
					if (!_.isArray(this.activeBuild[this.partName])) {
						selectedOption = Object.assign(_.cloneDeep(this.partInfo), selectedOption);
						selectedOption.products_id = this.partInfo.products_id;
					}
					selectedOption.quantity = buildPart.quantity;
				}

				requestUrl = `/update-part/${selectedOption.id}/${buildPart.id}/${buildPart.quantity}?pid=${selectedOption.products_id}&validate=true&step4=true`;

				axios({
					url: requestUrl,
					method: "GET",
					headers: {
						"token": CONFIG.SESSION
					}
				}).then(response => {
					this.changeBuildPrice(response.data);
					this.changeLoadingState(false);
				});
			} else {
				await this.duplicateBuild();
				await this.getSessionData();
				this.setBuildPartWithOptions(partOption, quantity);
			}
		},
		changeBuildPrice(pricingData) {
			if (pricingData.total) {
				if (pricingData.rules) {
					this.changeActiveRules(pricingData.rules);
				}
				this.$store.dispatch("setActiveBuild", pricingData.build);
				this.setBuildPrice(pricingData.total);
			} else {
				if (pricingData.price) {
					this.setBuildPrice(pricingData.price);
				} else {
					this.setBuildPrice(pricingData);
				}
			}
		},
		async setMultipleBuildParts(quantity) {
			if (await this.checkOwnership()) {
				this.disableButton = true;
				this.changeLoadingState(true);
				const partIndex = this.getBuildPartIndex();
				let selectedPartInfo = this.partInfo;

				if (partIndex >= 0) {
					selectedPartInfo = this.activeBuild[this.partName][this.getBuildPartIndex()];
				}

				if (quantity == "empty") {
					if (partIndex >= 0) {
						axios({
							url: `/delete-part/${this.partInfo.id}?pid=${this.partInfo.products_id}&validate=true&step4=true`,
							method: "GET",
							headers: {
								"token": CONFIG.SESSION
							}
						}).then(response => {
							this.changeBuildPrice(response.data);
							this.changeLoadingState(false);

							this.removeFanOrder();
						});
					} else {
						this.changeLoadingState(false);
						this.disableButton = false;
					}

					return;
				}

				if (!quantity) {
					quantity = 1;
				}

				let requestUrl = `/update-part/${selectedPartInfo.id}/${selectedPartInfo.id}/${quantity}?pid=${selectedPartInfo.products_id}&validate=true&step4=true`;

				if (!this.partInfo.colors) {
					if (this.activeBuild[this.partName][this.getBuildPartIndex()]) {
						requestUrl = `/update-part/${this.partInfo.id}/${this.activeBuild[this.partName][this.getBuildPartIndex()].id}/${quantity}?pid=${this.partInfo.products_id}&validate=true&step4=true`;
					} else if (this.partInfo.options && this.partInfo.options[0]) {
						requestUrl = `/update-part/${this.partInfo.options[0].id}/${this.partInfo.products_id}/${quantity}?pid=${this.partInfo.products_id}&validate=true&step4=true`;
					} else {
						requestUrl = `/update-part/${this.partInfo.id}/${this.partInfo.id}/${quantity}?pid=${this.partInfo.products_id}&validate=true&step4=true`;
					}
				}

				if (partIndex >= 0) {
					if (this.activeBuild[this.partName][partIndex].quantity == quantity) {
						axios({
							url: `/delete-part/${this.partInfo.id}?pid=${this.partInfo.products_id}&validate=true&step4=true&validate=true&step4=true`,
							method: "GET",
							headers: {
								"token": CONFIG.SESSION
							}
						}).then(response => {
							this.changeBuildPrice(response.data);
							this.changeLoadingState(false);

							this.removeFanOrder();
						});

					} else {
						axios({
							url: requestUrl,
							method: "GET",
							headers: {
								"token": CONFIG.SESSION
							}
						}).then(response => {
							this.changeBuildPrice(response.data);
							this.changeLoadingState(false);

							this.addFanOrder();
						});
					}
				} else {
					this.partInfo.quantity = quantity;
					axios({
						url: requestUrl,
						method: "GET",
						headers: {
							"token": CONFIG.SESSION
						}
					}).then(response => {
						this.changeBuildPrice(response.data);
						this.changeLoadingState(false);
						this.addFanOrder();
					});
				}
			} else {
				await this.duplicateBuild();
				await this.getSessionData();
				this.setMultipleBuildParts(quantity);
			}
		},
		addFanOrder() {
			if (this.partName == "caseFans" && !window.fansOrder.includes(this.partInfo.products_id)) {
				window.fansOrder.push(this.partInfo.products_id);
			}
		},
		removeFanOrder() {
			if (this.partName == "caseFans") {
				window.fansOrder = window.fansOrder.filter(fan => fan != this.partInfo.products_id);
			}
		},
		getRealCapacity(part) {
			if (typeof part === "undefined" || !part || part && !part.capacity) {
				return "";
			}

			const suffix = part.capacity.match(/([^\d]+)/)[0].trim();
			const realSize = parseInt(part.capacity) * Math.abs(part.slots);

			return `${realSize} ${suffix}`;
		}
	}
};
</script>

<style lang="scss" scoped>
    .btn-green {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

</style>
